import { Button, RoleBasedNavigationButtons } from '@/components/Elements';
import { InputField } from '@/components/Form';
import { usePatchPasswordReset } from '@/features/password-reset/api/patchPasswordReset';
import { PasswordResetLayout } from '@/features/password-reset/components/Layout';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

export const EditPasswordReset = () => {
  const { t } = useTranslation();
  const { mutate, isPending, error } = usePatchPasswordReset();
  const errorMessages = error?.response?.data?.errors;

  const [searchParams] = useSearchParams();
  const resetPasswordToken = searchParams.get('reset_password_token');

  const [requestSuccess, setRequestSuccess] = useState<boolean>(false);
  const [password, setPassword] = useState<string>('');
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>('');
  // 入力していて、かつパスワードとパスワード確認が一致しているか
  const isValidPassword =
    password && passwordConfirmation && password === passwordConfirmation;

  const canSubmit = isValidPassword;

  if (!resetPasswordToken)
    return (
      <PasswordResetLayout>
        <div>{t('パスワード再設定用のURLが不正です。')}</div>
      </PasswordResetLayout>
    );

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!canSubmit) return;

    mutate(
      {
        password,
        passwordConfirmation,
        resetPasswordToken,
      },
      {
        onSuccess: () => {
          setRequestSuccess(true);
        },
      }
    );
  };

  return (
    <PasswordResetLayout>
      <form className="w-full space-y-6" onSubmit={onSubmit}>
        {requestSuccess ? (
          <>
            <p>{t('パスワードが設定されました。')}</p>
            <div className="mt-10 flex gap-x-8">
              <RoleBasedNavigationButtons />
            </div>
          </>
        ) : (
          <>
            <div>
              {t(
                '8文字以上128文字以下で、大文字（A-Z）、小文字（a-z）、数字（0-9）、特殊文字（#?!@$%^&*-）をそれぞれ1文字以上含むよう設定してください。'
              )}
            </div>

            <InputField
              label={t('パスワード')}
              type="password"
              autoComplete="new-password"
              placeholder={t('新しいパスワードを入力...')}
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              error={!!errorMessages?.password}
              errors={errorMessages?.password}
              required
            />

            <div>
              <InputField
                label={t('パスワード（確認用）')}
                type="password"
                autoComplete="new-password"
                placeholder={t('新しいパスワードを再入力...')}
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.currentTarget.value)}
                error={!!password && !isValidPassword}
                errors={
                  !!password && !isValidPassword
                    ? [t('パスワードが一致しません。')]
                    : []
                }
                required
              />
            </div>

            <Button
              type="submit"
              size="sm"
              className="w-full"
              disabled={!canSubmit}
              isLoading={isPending}
            >
              {t('送信')}
            </Button>
          </>
        )}
      </form>
    </PasswordResetLayout>
  );
};
